var React = require('react');

function M (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.1764 17.049L24.9922 18.7293V18.785H15.7816V18.7293L17.6303 17.049C17.8275 16.8935 17.9219 16.6465 17.8768 16.404V5.66178C17.8768 5.20788 17.8768 4.59472 17.959 4.06915L11.7474 19H11.6735L5.24005 5.26362C5.10037 4.92121 5.05929 4.89732 4.96891 4.66639V13.6727C4.89189 14.2755 4.99752 14.8869 5.27291 15.4325L7.86107 18.7293V18.785H0.992188V18.7293L3.58034 15.4246C3.85371 14.8812 3.95927 14.2728 3.88435 13.6727V3.71878C3.92643 3.22867 3.77358 2.74151 3.4571 2.35708L1.62485 0.0557418V0H8.19794L13.7029 11.6341L18.5506 0H24.984V0.0557418L23.1764 2.00671C22.9598 2.16018 22.8515 2.41932 22.897 2.67561V16.404C22.8491 16.6538 22.9589 16.9072 23.1764 17.049Z","fill":"#0EE9C4"}));
}

M.defaultProps = {"width":"25","height":"19","viewBox":"0 0 25 19","fill":"none"};

module.exports = M;

M.default = M;
